module.exports = __webpack_public_path__ + "static/img/t4.d60af1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/t4.png
// module id = fWtK
// module chunks = 1